export enum ERROR_CODES {
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  BUSINESS_LOGIC_ERROR = "BUSINESS_LOGIC_ERROR",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  FORBIDDEN = "FORBIDDEN",
  ACCOUNT_SUSPENDED = "ACCOUNT_SUSPENDED",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
}
